import * as React from 'react';

import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';

import styled, { useTheme } from 'styled-components';

import { Translate } from 'react-localize-redux';

import Grid from '@components/basics/grid';
import Typography from '@components/basics/typography';

interface NotificationCollaboratorInviteTemplateProps {
  className?: string;
  isRead?: boolean;
}

export const NotificationAutomaticMerchCreatedTemplate: React.FC<
  NotificationCollaboratorInviteTemplateProps
> = ({ className, isRead }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const handleLink = (url: string) => {
    return dispatch(push(url));
  };

  return (
    <Translate>
      {({ translate }) => (
        <Grid className={className}>
          <Typography color={isRead ? theme.colors.tertiary : undefined}>
            {translate('NOTIFICATION.AUTOMATIC_MERCH_CREATED.1')}
          </Typography>
          <Link
            weight="700"
            color={isRead ? theme.colors.tertiary : undefined}
            onClick={() => handleLink('/catalog?type=merch')}
          >
            {translate('NOTIFICATION.AUTOMATIC_MERCH_CREATED.2')}
          </Link>
        </Grid>
      )}
    </Translate>
  );
};

export default NotificationAutomaticMerchCreatedTemplate;

const Link = styled(Typography)`
  cursor: pointer;
  opacity: 1;
  width: fit-content;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.5;
  }
`;
